import {UIButton} from "./Tools/Base/UIButton";
import {UISprite} from "./Tools/Base/UISprite";
import {UIText} from "./Tools/Base/UIText";
import {Core} from "../Base/Core";

export class VIPButton extends UIButton {
    constructor() {
        super();
        this.back = this.addChild(new UISprite("offers/vip-badge-bg"));
        this.icon = this.addChild(new UISprite("offers/crown"));
        this.label = this.addChild(new UIText(Core.Localizator.Get("vip")));
        this.SetActive(false);
        this.on("pointertap", () => Core.UI.vip.Show());
        this._initTapHighlight(this.back);
    }

    Update() {
        this.SetActive(false); // XXX: VIP temporary off
        // this.SetActive(
        //     !Core.Store.VipActive
        //     && GameManager.tutorialState == 0
        //     && Core.Store.IsInitialized
        //     && !Core.UI.game.rightPanel.firstCreatureOfferBtn.IsActive
        //     && !Core.UI.game.rightPanel.skipEpochsOfferBtn.IsActive
        // );
    }

    fitLayout(rect) {
        rect = rect.clone();
        this.position.copyFrom(rect);
        rect.x = rect.y = 0;

        this.back.scale.set(rect.width / this.back.texture.width);
        this.back.position.set(rect.width * 0.5, rect.height * 0.5);

        this.icon.scale.set(rect.width * 0.8 / this.icon.texture.width);
        this.icon.position.set(rect.width * 0.5, rect.height * 0.1);

        this.label.fitLayout(rect);
        this.label.position.set(rect.width * 0.5, rect.height * 0.6);
    }
}
